var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.cssClasses,style:({
        margin: '1rem',
        position: 'relative',
        width: `${_vm.width}`,
        height: `${_vm.height}`,
        ..._vm.styles
    })},[_c('canvas',{attrs:{"id":_vm.chartId}})])
}
var staticRenderFns = []

export { render, staticRenderFns }